<ng-container *transloco="let t">
  <app-page-template>
    <div class="container">
      <div class="pt-48-38 pb-300-228">
        <app-grey-card-with-title [title]="t('about.us.about.contact')" [removeContentPaddingTop]="true"
                                  [setHeadingMaxWidth350]="false">
          <div class="px-10">
            <div class="row pt-20">
              <div class="col-6 offset-3 text-center">
                <span class="pb-2 fw-bold">
                  {{ t('about.us.contact') }}
                </span>
                <p>
                  {{ t('about.us.reach') }} <a href="mailto:timing@stotinka.hr">timing&#64;stotinka.hr</a>
                </p>
                <p class="pb-2 pt-3 fw-bold">
                  {{ t('about.us.management') }}
                </p>
                <p>{{ contactManagement }}</p>
                <a href="mailto:{{contactManagementMail}}">{{ contactManagementMail }}</a>
                <p><a href="tel:{{contactManagementPhone}}">{{ contactManagementPhone }}</a></p>
                <p class="pb-2 pt-3 fw-bold">
                  {{ t('about.us.helpdesk') }}
                </p>
                <p>{{ contactHelpdesk }}</p>
                <a href="mailto:{{contactHelpdeskMail}}">{{ contactHelpdeskMail }}</a>
                <p><a href="tel:{{contactHelpdeskPhone}}">{{ contactHelpdeskPhone }}</a></p>
              </div>
            </div>

          </div>
        </app-grey-card-with-title>
        <div class="mt-30">
          <app-grey-card-with-title [title]="t('about.us.legal.information')" [removeContentPaddingTop]="true"
                                    [setHeadingMaxWidth350]="false">
            <div class="row">
              <div class="col text-center">
                <div class="d-flex flex-column">
                  <section class="text-center pt-20">
                    <p class="fw-bold">
                      {{ t('about.us.court.registry') }}
                    </p>
                    <a href="{{courtRegistryLink}}"
                       target="_blank">{{
                        t(
                          'about.us.commercial.court')
                      }}</a>
                    <p class="pt-4 fw-bold">
                      {{ t('about.us.court.number') }}
                    </p>
                    <p>
                      {{ courtNumber }}
                    </p>
                    <p class="pt-2 fw-bold">
                      {{ t('about.us.tax.number') }}
                    </p>
                    <p>
                      {{ taxNumber }}
                    </p>
                  </section>
                </div>
              </div>
            </div>
          </app-grey-card-with-title>
        </div>
        <div class="mt-30">
          <app-grey-card-with-title [title]="t('about.us.bank.account')" [removeContentPaddingTop]="true"
                                    [setHeadingMaxWidth350]="false">
            <div class="row">
              <div class="col text-center">
                <div class="d-flex flex-column">
                  <section class="text-center pt-3">
                    <a href="{{bankLink}}" target="_blank">
                      {{ bankName }}
                    </a>
                    <p>
                      {{ bankStreet }}
                    </p>
                    <p>
                      {{ bankPostalNumber }} {{ bankCity }}
                    </p>
                    <p>
                      {{ bankCountry }}
                    </p>
                    <p class="pt-4 fw-bold">
                      SWIFT
                    </p>
                    <p>
                      {{ bankSwiftCode }}
                    </p>
                    <p class="pt-2 text-uppercase">
                      IBAN
                    </p>
                    <p>
                      {{ bankIbanCode }}
                    </p>
                  </section>
                </div>
              </div>
            </div>
          </app-grey-card-with-title>
        </div>
        <div class="mt-30">
          <app-grey-card-with-title [removeContentPaddingTop]="true">
            <div class="row row-cols-1 row-cols-lg-2 pt-5">
              <div class="col">
                <div class="d-flex align-items-center justify-content-center">
                  <div>
                    <section>
                      <span class="pb-2 fw-bold">
                        {{ t('about.us.headquarters') }}
                      </span>
                      <p>
                        {{ headquartersName }}
                      </p>
                      <p>
                        {{ headquartersStreet }}
                      </p>
                      <p>
                        {{ headquartersPostalNumber }} {{ headquartersCity }}
                      </p>
                      <p>
                        {{ headquartersCountry }}
                      </p>
                    </section>
                    <section class="pt-5">
                      <span class="pb-2 fw-bold">
                        {{ t('about.us.office') }}
                      </span>
                      <a href="http://www.tehnopark.hr/" target="_blank">
                        {{ officeName }}
                      </a>
                      <p>
                        {{ officeStreet }}
                      </p>
                      <p>
                        {{ officePostalNumber }} {{ officeCity }}
                      </p>
                      <p>
                        {{ officeCountry }}
                      </p>
                    </section>
                  </div>
                </div>
              </div>
              <div class="col pt-5 pt-lg-0">
                <div class="position-relative d-flex h-100">
                  <app-leaflet-maps-wrapper [lat]="lat" [lng]="lng" [languages]="[]"
                                            [isShowLocationMarkerEnabled]="true"
                                    [positionAbsolute]="true"/>
                </div>
              </div>
            </div>
          </app-grey-card-with-title>
        </div>
        <div class="mt-30">
          <app-grey-card-with-title [title]="t('about.us.supported.by')" [removeContentPaddingTop]="true"
                                    [setHeadingMaxWidth350]="false">
            <div class="d-flex flex-row align-items-center justify-content-center pt-5">
              <a href="{{supportedByTehnoParkLink}}"
                 target="_blank"> <img src="{{supportedByTehnoParkLogo}}" alt="{{supportedByTehnoParkAlt}}"
                                       class="mb-3 mb-md-0 me-5" width="200"></a>
              <a href="{{supportedByRazaLink}}"
                 target="_blank">
                <img src="{{supportedByRazakLogo}}" alt="{{supportedByRazaAlt}}" width="200"></a>
            </div>
          </app-grey-card-with-title>
        </div>
      </div>
    </div>
    <app-footer/>
  </app-page-template>
</ng-container>




